module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFabricio) ? _c('div', {
    staticClass: "simulacao-geral"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('h3', [_vm._v("Quadro Geral Preventivas - Simulação")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/importar-preventivas"
    }
  }, [_vm._v("\n          Importar Dados\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "filtroFornecedor"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroFornecedor),
      expression: "filtroFornecedor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroFornecedor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroFornecedor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.fornecedores), function(fornecedor) {
    return _c('option', {
      key: fornecedor,
      domProps: {
        "value": fornecedor
      }
    }, [_vm._v(_vm._s(fornecedor))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "filtroUf"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroUf),
      expression: "filtroUf"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroUf"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroUf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf,
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.carregando) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : (_vm.erro) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.erro) + "\n      ")]) : _c('div', {
    staticClass: "tabela-container"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', [_vm._v("Regional")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("UF")]), _vm._v(" "), _vm._l((_vm.meses), function(mes, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(mes))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.dadosFiltrados), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.fornecedor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regional))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uf))]), _vm._v(" "), _vm._l((_vm.meses), function(mes, mesIndex) {
      return _c('td', {
        key: mesIndex
      }, [_vm._v("\n                " + _vm._s(_vm.obterValorMes(item, mesIndex)) + "\n              ")])
    })], 2)
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Totais")]), _vm._v(" "), _vm._l((_vm.meses), function(mes, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                " + _vm._s(_vm.calcularTotalMes(index)) + "\n              ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "resumo"
  }, [_c('h4', [_vm._v("Resumo por Fornecedor")]), _vm._v(" "), _c('div', {
    staticClass: "grafico-container"
  }, [_c('canvas', {
    ref: "graficoFornecedores",
    attrs: {
      "id": "graficoFornecedores"
    }
  })])])])])]) : _c('div', {
    staticClass: "alert alert-warning m-3"
  }, [_vm._v("Acesso restrito.")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f927f76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/simulacaoPreventivas/SimulacaoGeral.vue
// module id = 978
// module chunks = 1